const animations = Object.freeze({
  loadingBlue: require('./loading-ring-blue.json'),
  primaryButton: require('./primaryButtonAnimation.json'),
});

export default animations;
